// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"dacebb90","403":"1f1a15cf"}[chunkId] + ".chunk.js";
};